export default function ({ i18n, $axios, $config, $dayjs }) {
    i18n.onLanguageSwitched = function (oldLocale, newLocale) {
        $axios.defaults.baseURL = $config.apiBaseURL + '/api/' + newLocale;
        $dayjs.locale(newLocale);
    };
}
